@if (loading()) {
<div class="p-0! bg-surface border border-hover rounded-md overflow-hidden!">
  <div class="px-1 py-1 flex flex-col gap-y-0.5">
    <soft-loading-skeleton />
    <soft-loading-skeleton />
  </div>
</div>
} @else {
<soft-ds-card
  density="none"
  [accent]="statusColor()"
  [accentColor]="accentColor()"
  [class.ring-2]="selected()"
  [class.ring-primary]="selected()"
  [class.opacity-60]="deleted()"
>
  <div class="flex flex-col gap-0.5 text-xs p-[0.3rem_0.3rem_0.3rem_1rem]">
    <div class="flex gap-1 items-center font-semibold">
      @if (modeLetter()) {
      <soft-ds-badge [variant]="modeVariant()" size="sm" class="shrink-0">
        {{ modeLetter() }}
      </soft-ds-badge>
      }
      <span class="text-black min-w-0 flex-1 truncate">{{ title() }}</span>
      @if(tour()){
      <soft-ds-badge variant="outline" size="sm" class="shrink-0">
        Tour{{tour()}}
      </soft-ds-badge>
      } @if (locked()) {
      <soft-ds-icon name="fa-regular fa-lock" class="shrink-0" />
      }
    </div>
    <span class="text-light" [class.line-clamp-1]="clampSubtitle()">
      {{ subtitle() }}
    </span>
    @if (badges().length > 0) {
    <div class="flex gap-1">
      @for (badge of badges(); track badge.icon) { @if(badge.label){
      <soft-ds-badge variant="outline" size="sm">
        @if (badge.icon) {
        <soft-ds-icon [name]="badge.icon" />
        }
        <span>{{ badge.label | translate }}</span>
      </soft-ds-badge>
      } }
    </div>
    } @if(details()) {
    <div class="flex flex-col gap-1 border-t pt-1 mt-1">
      @for(detail of details(); track detail.label){
      <div class="flex flex-row gap-1">
        <div class="flex text-light">
          @if (detail.icon) {
          <soft-ds-icon [name]="detail.icon" />
          }
          <span>{{detail.label}}</span>
        </div>
        <span class="break-all">{{detail.detail}}</span>
      </div>
      }
    </div>
    }
  </div>
</soft-ds-card>
}
